import { Calendar, MapPin, Hotel, Utensils, Coffee, CarFront, 
    // Sparkles 
} from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const InfoKonvensiFees = () => {
    const facilities = [
        {
            id: 1,
            icon: <MapPin className="w-5 h-5" />,
            title: "Lokasi Pelaksanaan",
            desc: "Bali Nusa Dua Convention Center (BNDCC). Tempat konvensi terbaik di pulau Bali."
        },
        {
            id: 2,
            icon: <Hotel className="w-5 h-5" />,
            title: "Akomodasi Hotel",
            desc: "Hotel bintang 4 (Twin Room) di kawasan Nusa Dua, Jimbaran, atau Sunset Road Kuta (2-4 Okt)."
        },
        {
            id: 3,
            icon: <Utensils className="w-5 h-5" />,
            title: "Konsumsi Buffet",
            desc: "2x Makan siang prasmanan dan 2x makan malam prasmanan di area BNDCC."
        },
        {
            id: 4,
            icon: <Coffee className="w-5 h-5" />,
            title: "Coffee Break",
            desc: "Empat kali coffee break eksklusif selama rangkaian acara di BNDCC."
        },
        {
            id: 5,
            icon: <CarFront className="w-5 h-5" />,
            title: "Transportasi",
            desc: "Penjemputan bandara serta layanan antar-jemput selama kegiatan berlangsung."
        }
    ];

    return (
        <div className="mx-auto antialiased">
            <Card className="bg-white dark:bg-gray-800 mb-3 border-none shadow-xl dark:shadow-2xl overflow-hidden rounded-[1rem] transition-colors duration-300">
                {/* Accent Top Bar - Gradient subtle */}
                <CardHeader className="pb-4 pt-8 px-8 bg-gradient-to-b bg-white dark:bg-gray-800">
                    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-4">
                        <div className="space-y-1">
                            <div className="flex items-center gap-2 mb-2">
                                <Badge className="bg-blue-700 hover:bg-blue-800 text-white px-3 py-0.5 rounded-full text-[10px] font-bold tracking-widest uppercase">
                                    Official Package
                                </Badge>
                                <span className="text-[11px] font-bold text-blue-600 flex items-center">
                                    <Calendar className="mr-1 h-3 w-3" />
                                    2 — 4 OKTOBER 2026
                                </span>
                            </div>
                            <CardTitle className="text-xl font-black text-slate-900 dark:text-white leading-tight flex items-center gap-2">
                                Fasilitas Peserta Konvensi
                                {/* <Sparkles className="w-5 h-5 text-amber-400 fill-amber-400 hidden md:block" /> */}
                            </CardTitle>
                        </div>
                    </div>
                <div className="h-1.5 bg-gradient-to-r from-blue-600 to-indigo-500 opacity-80" />
                </CardHeader>

                <CardContent className="px-6 md:px-8 pb-8">
                    {/* Grid Layout 2 Kolom */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {facilities.map((item, index) => (
                            <div
                                key={item.id}
                                className={`group p-4 rounded-2xl border border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-900/40 hover:bg-white dark:hover:bg-gray-700/60 hover:shadow-md transition-all duration-300 ${index === 4 ? 'md:col-span-2' : ''}`}
                            >
                                <div className="flex gap-4 items-start">
                                    {/* Icon Container with Adaptive Colors */}
                                    <div className="flex-none flex items-center justify-center w-10 h-10 rounded-xl bg-white dark:bg-gray-800 shadow-sm text-blue-600 dark:text-blue-400 group-hover:bg-blue-600 dark:group-hover:bg-blue-500 group-hover:text-white transition-colors duration-300 border border-gray-100 dark:border-gray-700">
                                        {item.icon}
                                    </div>

                                    <div className="space-y-1">
                                        <h4 className="font-bold text-gray-800 dark:text-gray-200 text-sm tracking-tight flex items-center gap-2">
                                            <span className="text-[10px] bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 w-5 h-5 flex items-center justify-center rounded-full font-black">
                                                {item.id}
                                            </span>
                                            {item.title}
                                        </h4>
                                        <p className="text-[12px] text-gray-600 dark:text-gray-400 leading-relaxed font-medium">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Minimalist Footer */}
                    <div className="mt-8 pt-5 border-t border-gray-100 dark:border-gray-700 flex flex-col items-center justify-center space-y-2">
                        <p className="text-[10px] text-gray-400 dark:text-gray-500 font-bold uppercase tracking-[0.3em] text-center">
                            Nusa Dua • Bali
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default InfoKonvensiFees;